<style lang="scss">

</style>

<template>
  <section class="section">
    <div class="container is-centered p-4" :class="isDarkMode ? 'has-background-dark' : 'has-background-white-bis'">
      <form @submit.prevent="submit">
        <!--        <div class="field">-->
        <!--          <label for="first_name" >First Name</label>-->
        <!--          <div class="control">-->
        <!--            <input v-model="form.first_name" :error="form.errors.first_name" type="text" id="name" class="input" name="first_name" placeholder="Your Last Name">-->
        <!--          </div>-->
        <!--        </div>-->
        <text-input
          :label-class="isDarkMode ? 'has-text-primary-light' : ''"
          :input-class="isDarkMode ? 'has-text-primary-light has-background-dark' : ''"
          v-model="form.first_name" :error="form.errors.first_name" label="First Name" placeholder="Your First Name" />
        <text-input
          :label-class="isDarkMode ? 'has-text-primary-light' : ''"
          :input-class="isDarkMode ? 'has-text-primary-light has-background-dark' : ''"
          v-model="form.last_name" :error="form.errors.last_name" label="Last Name" placeholder="Your Last Name" />
        <text-input
          :label-class="isDarkMode ? 'has-text-primary-light' : ''"
          :input-class="isDarkMode ? 'has-text-primary-light has-background-dark' : ''"
          v-model="form.email" :error="form.errors.email" label="Email" placeholder="Your Email Address" />
        <text-input
          :label-class="isDarkMode ? 'has-text-primary-light' : ''"
          :input-class="isDarkMode ? 'has-text-primary-light has-background-dark' : ''"
          v-model="form.phone" :error="form.errors.phone" label="Phone" placeholder="Your Phone Number" />
        <!--        <div class="field">-->
        <!--          <label for="name" >Last Name</label>-->
        <!--          <div class="control">-->
        <!--            <input v-model="form.last_name" :error="form.errors.last_name" type="text" id="last_name" class="input" name="last_name" placeholder="Your Last Name">-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="field">-->
        <!--          <label for="email">Your Email</label>-->
        <!--          <div class="control">-->
        <!--            <input v-model="form.email" :error="form.errors.email" type="text" class="input" name="email" id="email" placeholder="Your Name">-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="field">-->
        <!--          <label for="phone" id="name">Your Phone Number</label>-->
        <!--          <div class="control">-->
        <!--            <input v-model="form.phone" :error="form.errors.phone" type="text" id="phone" class="input" name="phone" placeholder="Your Phone Number">-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="field">
          <label id="name" for="name" :class="{'has-text-primary-light': isDarkMode}" class="label">Message</label>
          <div class="control">
            <textarea v-model="form.message" class="input" :class="{error: form.errors.message, 'has-background-dark has-text-primary-light': isDarkMode}" rows="5" style="height: 120px;" name="body" placeholder="Message" />
            <div v-if="form.errors.message" class="help is-danger form-error">{{ form.errors.message }}</div>
          </div>
        </div>

        <div class="p-2 is-flex is-justify-content-space-between is-align-items-end is-fullwidth">
<!--          <div class="g-recaptcha" data-sitekey="6LeMjGskAAAAAFst9pOLT5TLdTr7QVzNtxXa419o" data-action="LOGIN" />-->
          <vue-recaptcha ref="recaptcha" :sitekey="siteKey" @verify="onCaptchaVerify">
          <span v-if="recaptcha_error_message" class="help form-error is-danger">
            {{ recaptcha_error_message }}
          </span></vue-recaptcha>
          <loading-button :loading="form.processing" class="button is-link is-info" type="submit">Submit</loading-button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import TextInput from '@/Shared/TextInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import { VueRecaptcha } from 'vue-recaptcha';
import axios from "axios";

export default {
  name: 'LeadForm',
  components: {VueRecaptcha, LoadingButton, TextInput},
  props: {
    uuid: String,
    sectorTarget: Object,
    isDarkMode: {type: Boolean, default: false},
  },
  data() {
    return {
      siteKey: "6LeMjGskAAAAAFst9pOLT5TLdTr7QVzNtxXa419o",
      recaptcha_error: false,
      form: this.$inertia.form({
        uuid: this.$page.props.uuid,
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        message: '',
        'g-recaptcha-response': '',
      }),
    }
  },
  computed: {
    recaptcha_error_message: function() {
      if (this.form.errors['g-recaptcha-response']) {
        return this.form.errors['g-recaptcha-response']
      } else if (!this.recaptcha_error) {
        return null
      } else {
        return 'Please confirm you are not a robot.'
      }
    }
  },
  methods: {

    onCaptchaVerify: function(token) {
      // Provide the token response to the form object.
      this.recaptcha_error = false
      this.form['g-recaptcha-response'] = token
    },

    clearForm() {
      this.form = this.$inertia.form({
        uuid: this.$page.props.uuid,
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        message: '',
        'g-recaptcha-response': '',
      });
      this.$refs.recaptcha.reset()
    },

    submit: async function () {

      if (this.form['g-recaptcha-response']){
        try {
          let { data } = await axios.post('/lead-form', this.form);

          this.$buefy.toast.open({message: 'Thank you! Your request has been sent.', type: 'is-success'})
          this.clearForm();
        }catch(e) {
          if(e.response) {
            let errors = {}
            _.each(e.response.data.errors, (value, key) => {
              errors[key] = value[0]
            })
            this.$refs.recaptcha.reset()
            this.form.errors = errors;
          }
        }
        // this.form.post('/lead-form', {
        //   onSuccess: (data) => {
        //     console.log(this.form.errors.message);
        //     this.$buefy.toast.open({message: 'Thank you! Your request has been sent.', type: 'is-success'})
        //   },
        //   onError: (data) => {
        //     this.$buefy.toast.open({
        //       message: 'Request failed. Please fix the issues highlighted below.',
        //       type: 'is-danger',
        //     })
        //     this.$refs.recaptcha.reset()
        //   },
        // },
        // )
      }
      else {
        this.recaptcha_error = true
        this.$buefy.toast.open({
          message: 'Request failed. Please fix the issues highlighted below.',
          type: 'is-danger',
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">

</style>
